import { __decorate } from 'tslib';
import { Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { isPresent } from '@taiga-ui/cdk';
import { sizeBigger, TuiPrimitiveCheckboxModule } from '@taiga-ui/core';
import { TuiSelectOptionComponent } from '@taiga-ui/kit/components/select-option';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core';
import * as ɵngcc2 from '@angular/common';

function TuiMultiSelectOptionComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
let TuiMultiSelectOptionComponent = class TuiMultiSelectOptionComponent extends TuiSelectOptionComponent {
    get size() {
        return sizeBigger(this.option.size) ? 'l' : 'm';
    }
    get selected() {
        return (isPresent(this.option.value) &&
            isPresent(this.control.value) &&
            !!this.control.value.find((item) => this.matcher(item, this.option.value)));
    }
};
TuiMultiSelectOptionComponent.ɵfac = /*@__PURE__*/ function () { let ɵTuiMultiSelectOptionComponent_BaseFactory; return function TuiMultiSelectOptionComponent_Factory(t) { return (ɵTuiMultiSelectOptionComponent_BaseFactory || (ɵTuiMultiSelectOptionComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiMultiSelectOptionComponent)))(t || TuiMultiSelectOptionComponent); }; }();
TuiMultiSelectOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiMultiSelectOptionComponent, selectors: [["tui-multi-select-option"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 5, consts: [[1, "t-checkbox", 3, "size", "value"], [4, "ngTemplateOutlet"]], template: function TuiMultiSelectOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "tui-primitive-checkbox", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, TuiMultiSelectOptionComponent_ng_container_2_Template, 1, 0, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("size", ctx.size)("value", ɵngcc0.ɵɵpipeBind1(1, 3, ctx.selected$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.context.$implicit);
    } }, directives: [ɵngcc1.TuiPrimitiveCheckboxComponent, ɵngcc2.NgTemplateOutlet], pipes: [ɵngcc2.AsyncPipe], styles: ["@-webkit-keyframes retrigger{from{left:1px}to{left:2px}}@keyframes retrigger{from{left:1px}to{left:2px}}[_nghost-%COMP%]{display:flex;flex:1;align-items:center;overflow:hidden;-webkit-animation:1s retrigger;animation:1s retrigger}.t-checkbox[_ngcontent-%COMP%]{margin-right:.75rem}"], changeDetection: 0 });

let TuiMultiSelectOptionModule = class TuiMultiSelectOptionModule {
};
TuiMultiSelectOptionModule.ɵfac = function TuiMultiSelectOptionModule_Factory(t) { return new (t || TuiMultiSelectOptionModule)(); };
TuiMultiSelectOptionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiMultiSelectOptionModule });
TuiMultiSelectOptionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TuiPrimitiveCheckboxModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiMultiSelectOptionComponent, [{
        type: Component,
        args: [{
                selector: 'tui-multi-select-option',
                template: "<tui-primitive-checkbox\n    class=\"t-checkbox\"\n    [size]=\"size\"\n    [value]=\"selected$ | async\"\n></tui-primitive-checkbox>\n<ng-container *ngTemplateOutlet=\"context.$implicit\"></ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["@-webkit-keyframes retrigger{from{left:1px}to{left:2px}}@keyframes retrigger{from{left:1px}to{left:2px}}:host{display:flex;flex:1;align-items:center;overflow:hidden;-webkit-animation:1s retrigger;animation:1s retrigger}.t-checkbox{margin-right:.75rem}"]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiMultiSelectOptionModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiPrimitiveCheckboxModule],
                declarations: [TuiMultiSelectOptionComponent],
                exports: [TuiMultiSelectOptionComponent],
                entryComponents: [TuiMultiSelectOptionComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiMultiSelectOptionModule, { declarations: function () { return [TuiMultiSelectOptionComponent]; }, imports: function () { return [CommonModule, TuiPrimitiveCheckboxModule]; }, exports: function () { return [TuiMultiSelectOptionComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiMultiSelectOptionComponent, TuiMultiSelectOptionModule };

